// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import {
  ParticipantValidationStages,
} from '../../../models';
import { AppService } from '../app.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export abstract class InteractionAuthorizationBaseService {
  constructor(protected appService: AppService) {}

  setValidationStage(stage: ParticipantValidationStages) {}

  abstract validateInteractionToken(id: string): void;
}
